import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import { Row, Col } from "react-flexbox-grid";
import { withStyles } from "@material-ui/core/styles";
import { Formik, Form, FieldArray } from "formik";
import { Mutation, compose } from "react-apollo";
import gql from "graphql-tag";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { withNotification } from "../notification/context";
import BorderZone from "../border-zone";
import DescriptionsArray from "../descriptions";

const CREATE = gql`
  mutation createResearcher($researcher: ResearcherInput!) {
    createResearcher(researcher: $researcher) {
      id
      name
      credentials
      descriptions
      photo
    }
  }
`;

const styles = theme => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2
  },
  appBar: {
    position: "relative"
  },
  flex: {
    flex: 1
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  borderZone: {
    borderWidth: 2,
    borderColor: "#DCDCDC",
    borderStyle: "dashed",
    borderRadius: 5,
    margin: theme.spacing.unit * 1,
    padding: theme.spacing.unit * 2
  }
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const CreateUserModal = ({ classes, openNotification, query }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Mutation
      mutation={CREATE}
      update={(cache, { data: { createResearcher } }) => {
        const { allResearchers } = cache.readQuery({ query });
        cache.writeQuery({
          query,
          data: { allResearchers: allResearchers.concat([createResearcher]) }
        });
      }}
    >
      {createUser => (
        <Formik
          initialValues={{ name: "", credentials: "", descriptions: [] }}
          onSubmit={(values, { resetForm }) => {
            createUser({ variables: { researcher: values } })
              .then(() => {
                openNotification("Investigador creado correctamente.");
                resetForm();
                handleClose();
              })
              .catch(() => {
                openNotification("Error creando el investigador");
                //handleClose();
              });
          }}
        >
          {({ values, errors, touched, handleChange, handleSubmit }) => {
            return (
              <Form>
                <Tooltip title="Crear investigador" placement="left">
                  <Fab
                    className={classes.fab}
                    color="primary"
                    onClick={handleClickOpen}
                  >
                    <AddIcon />
                  </Fab>
                </Tooltip>
                <Dialog
                  fullScreen
                  TransitionComponent={Transition}
                  open={open}
                  onClose={handleClose}
                >
                  <AppBar className={classes.appBar}>
                    <Toolbar>
                      <IconButton
                        color="inherit"
                        onClick={handleClose}
                        aria-label="Close"
                      >
                        <CloseIcon />
                      </IconButton>
                      <Typography
                        variant="h6"
                        color="inherit"
                        className={classes.flex}
                      >
                        Crear Investigador
                      </Typography>
                      <Button color="inherit" onClick={handleSubmit}>
                        Guardar
                      </Button>
                    </Toolbar>
                  </AppBar>
                  <DialogContent>
                    <Row style={{ marginRight: 10 }}>
                      <Col xs={12} md={6}>
                        <TextField
                          required
                          name="name"
                          id="outlined-name"
                          label="Nombre"
                          className={classes.textField}
                          value={values.name}
                          onChange={handleChange}
                          margin="normal"
                          variant="outlined"
                          error={errors.name && touched.name && errors.name}
                          fullWidth
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </Col>
                      <Col xs={12} md={6}>
                        <TextField
                          required
                          name="credentials"
                          id="credentials"
                          label="Credenciales"
                          className={classes.textField}
                          value={values.credentials}
                          onChange={handleChange}
                          margin="normal"
                          variant="outlined"
                          error={
                            errors.credentials &&
                            touched.credentials &&
                            errors.credentials
                          }
                          fullWidth
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <BorderZone title="Descripción">
                          <FieldArray name="descriptions">
                            {helpers => (
                              <DescriptionsArray
                                itemKey="descriptions"
                                label="Parrafo"
                                values={values}
                                arrayHelpers={helpers}
                              />
                            )}
                          </FieldArray>
                        </BorderZone>
                      </Col>
                    </Row>
                  </DialogContent>
                </Dialog>
              </Form>
            );
          }}
        </Formik>
      )}
    </Mutation>
  );
};

export default compose(
  withStyles(styles),
  withNotification
)(CreateUserModal);



// WEBPACK FOOTER //
// ./src/components/researchers/add-user-button.js